import { Breadcrumbs, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { Link, withRouter,useLocation } from 'react-router-dom';
import { getLastFiveBreadCrumbLocations } from '../../../router/RouterHelpers';

const useStyles = makeStyles(theme => ({
    div: {
        backgroundColor: "#fff",
        padding: '15px 13px',
        margin: '-5px -10px 10px -10px'
    },
}));
const chatHistoryLocation="cms/contract/ai-chats-history"

function ContractsV2Breadcrumbs({
    root = '/cms/contracts',
    breadcrumbItems, currentDirectory, selectContractsIds, handleRefresh,isEdit=false,
    actions: { moveDirectoryOrContracts, resetSelectedContracts } }) {
    const classes = useStyles();
    const currentLocation = useLocation().pathname;
    const isContractsDetailsPage=currentLocation.includes('/cms/contract/edit') 
    const isContractsViewPage=currentLocation.includes("cms/contract/view")
    const isAiChatHistoryPage=currentLocation.includes(chatHistoryLocation)
    const isAiChatPage=currentLocation.includes("cms/contract/ai-chat/")
    const isAiFeaturePage=currentLocation.includes("ai-chats")
    const lastFiveLocations=getLastFiveBreadCrumbLocations("cms")
    const lastLocation=lastFiveLocations[lastFiveLocations?.length-1]

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedItems = JSON.parse(e.dataTransfer.getData('items'));
        onDrop(droppedItems, e.target.id);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const onDrop = (droppedItems, folderId) => {
        const destinationDirectoryId = folderId.split('folder-')[1];
        let contractIds = [];
        let directoryIds = [];
        if (selectContractsIds.length > 0) {
            for (let item of selectContractsIds) {
                const splittedItem = item.split('-');
                if (splittedItem[0] === 'contracts') {
                    contractIds.push(splittedItem[1]);
                } else if (splittedItem[0] === 'folder') {
                    directoryIds.push(splittedItem[1])
                }
            }
        } else {
            for (let item of droppedItems) {
                const splittedItem = item.split('-');
                if (splittedItem[0] === 'contracts') {
                    contractIds.push(splittedItem[1]);
                } else if (splittedItem[0] === 'folder') {
                    directoryIds.push(splittedItem[1])
                }
            }
        }
        const payload = {
            contractIds,
            directoryIds,
            destinationDirectoryId: destinationDirectoryId === 'root' ? undefined : destinationDirectoryId
        }
        moveDirectoryOrContracts(payload, handleCallback);
    };

    const handleCallback = () => {
        handleRefresh();
        resetSelectedContracts();
    }

    const getBreadCrumbsItems = () => { 
        if(!isContractsDetailsPage && !isContractsViewPage &&  !isAiFeaturePage  &&  !isAiChatPage) return breadcrumbItems
        if(!currentDirectory) return []
        else return [...breadcrumbItems,{id:currentDirectory?.parentId,name:currentDirectory?.parentName}]
    }

    return (
        <>
            <div className={`${classes.div} bread-crumb`}>
                <Breadcrumbs separator=">" aria-label="breadcrumb">
                    <Link id={`folder-root`} onDragOver={handleDragOver} onDrop={handleDrop} className='breadcrumb-link' to={root + `/root`} color="inherit" >
                        Contracts
                    </Link>
                    {getBreadCrumbsItems().map((breadcrumb, index) =>
                        <Link id={`folder-${breadcrumb.id}`} onDragOver={handleDragOver} onDrop={handleDrop} className='breadcrumb-link' to={root + `/${breadcrumb.id}`} key={index.toString()}  color="inherit" >
                            {breadcrumb.name}
                        </Link>
                    )}
                    {(!isContractsDetailsPage && !isContractsViewPage && currentDirectory && !isAiFeaturePage &&  !isAiChatPage) &&
                        <Typography className='breadcrumb-active' >{currentDirectory.parentName}</Typography>
                    }

                    { isAiChatPage && lastLocation?.includes(chatHistoryLocation) &&
                         <Link className='breadcrumb-link' to={lastLocation}  color="inherit" >
                       History
                        </Link>
                    }

                    { isAiChatHistoryPage &&
                        <Typography className='breadcrumb-active' >History</Typography>
                    }

                    { isAiChatPage &&
                        <Typography className='breadcrumb-active' >Sliced IQ</Typography>
                    }

                    {isContractsDetailsPage &&
                        <Typography className='breadcrumb-active' >{`${isEdit ? 'Edit':'Create'} Contract`}</Typography>
                    }

                    {isContractsViewPage && 
                        <Typography className='breadcrumb-active'>Contract Details</Typography>
                    }

                </Breadcrumbs>
            </div>
        </>
    )
}

export default withRouter(ContractsV2Breadcrumbs as any)